import useSetChartSelections from "features/Charting/hooks/useSetChartSelections";
import { useCallback, useMemo } from "react";
import { MetadataType } from "types/metadata";
import { ExerciseRepetition } from "types";

function useChartRepMetrics() {
  const setSelections = useSetChartSelections();

  const setMeasureMetricAtIndex = useCallback(
    (measureIndex: number) => (event: unknown, measureMetric: ExerciseRepetition) => {
      setSelections((prev) => ({
        measures: prev.measures.map((prevMeasure, prevMeasureIndex) => {
          if (measureIndex !== prevMeasureIndex) {
            return prevMeasure;
          }

          if (prevMeasure.type !== MetadataType.EXERCISE) {
            throw new Error("You can only select a rep metric on an Exercise");
          }

          return { ...prevMeasure, repMetric: measureMetric };
        }),
      }));
    },
    [setSelections]
  );

  return useMemo(
    () => ({
      onChangeAtIndex: setMeasureMetricAtIndex,
    }),
    [setMeasureMetricAtIndex]
  );
}
export default useChartRepMetrics;
